module.exports = __webpack_public_path__ + "img/IEC13773.1497deac.png";